import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    if (!sessionId) { setError("No encontramos tu sesión de Google."); return; }
    api.post("/auth/session", { session_id: sessionId }, { withCredentials: true }).then(async (response) => {
      window.localStorage.setItem("session_token", response.data.session_token);
      const draft = window.localStorage.getItem("onboarding_draft");
      if (draft) {
        try { await api.post("/onboarding/complete", JSON.parse(draft)); } catch (error) { console.warn("No se pudo guardar el onboarding", error); }
        window.localStorage.removeItem("onboarding_draft");
      }
      window.history.replaceState({}, "", "/");
      navigate("/");
    }).catch(() => setError("No pudimos iniciar sesión. Intenta de nuevo."));
  }, [navigate]);
  return <main className="app-loading" data-testid="auth-callback-status">{error || "Preparando tu cuenta segura..."}</main>;
}